import type { Template } from "@/types";

export const PO_04_H0_V4: Template[] = [
{
    id: "po-04-h0v4-01",
    name: "PO 01 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 32, y: 205, width: 262, height: 445, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 205, width: 262, height: 445, rotation: 0, imageRotation: 0 },
            { id: "3", x: 572, y: 205, width: 262, height: 445, rotation: 0, imageRotation: 0 },
            { id: "4", x: 842, y: 205, width: 262, height: 445, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h0v4-02",
    name: "PO 02 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 191, width: 279, height: 472, rotation: 0, imageRotation: 0 },
        { id: "2", x: 287, y: 191, width: 278, height: 472, rotation: 0, imageRotation: 0 },
        { id: "3", x: 573, y: 191, width: 278, height: 472, rotation: 0, imageRotation: 0 },
        { id: "4", x: 859, y: 191, width: 278, height: 472, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-03",
    name: "PO 03 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 29, y: 214, width: 252, height: 426, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 214, width: 251, height: 426, rotation: 0, imageRotation: 0 },
        { id: "3", x: 597, y: 214, width: 252, height: 426, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 214, width: 251, height: 426, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-04",
    name: "PO 04 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 34, y: 172, width: 301, height: 508, rotation: 0, imageRotation: 0 },
        { id: "2", x: 343, y: 262, width: 195, height: 330, rotation: 0, imageRotation: 0 },
        { id: "3", x: 598, y: 262, width: 195, height: 330, rotation: 0, imageRotation: 0 },
        { id: "4", x: 801, y: 172, width: 301, height: 508, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-05",
    name: "PO 05 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 26, y: 141, width: 341, height: 572, rotation: 0, imageRotation: 0 },
        { id: "2", x: 683, y: 141, width: 338, height: 572, rotation: 0, imageRotation: 0 },
        { id: "3", x: 375, y: 141, width: 167, height: 282, rotation: 0, imageRotation: 0 },
        { id: "4", x: 375, y: 431, width: 167, height: 282, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-06",
    name: "PO 06 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 35, y: 41, width: 456, height: 773, rotation: 0, imageRotation: 0 },
        { id: "2", x: 499, y: 503, width: 185, height: 310, rotation: 0, imageRotation: 0 },
        { id: "3", x: 692, y: 503, width: 185, height: 310, rotation: 0, imageRotation: 0 },
        { id: "4", x: 885, y: 503, width: 185, height: 310, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-07",
    name: "PO 07 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 79, y: 81, width: 409, height: 691, rotation: 0, imageRotation: 0 },
        { id: "2", x: 600, y: 176, width: 297, height: 503, rotation: 0, imageRotation: 0 },
        { id: "3", x: 905, y: 81, width: 201, height: 342, rotation: 0, imageRotation: 0 },
        { id: "4", x: 905, y: 431, width: 201, height: 342, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-08",
    name: "PO 08 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 79, y: 81, width: 409, height: 691, rotation: 0, imageRotation: 0 },
        { id: "2", x: 810, y: 176, width: 297, height: 503, rotation: 0, imageRotation: 0 },
        { id: "3", x: 601, y: 81, width: 201, height: 342, rotation: 0, imageRotation: 0 },
        { id: "4", x: 601, y: 431, width: 201, height: 341, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-09",
    name: "PO 09 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 79, width: 410, height: 696, rotation: 0, imageRotation: 0 },
        { id: "2", x: 678, y: 79, width: 410, height: 696, rotation: 0, imageRotation: 0 },
        { id: "3", x: 467, y: 79, width: 203, height: 344, rotation: 0, imageRotation: 0 },
        { id: "4", x: 467, y: 431, width: 203, height: 344, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h0v4-10",
    name: "PO 10 - H0V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h0_v4_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 79, width: 410, height: 696, rotation: 0, imageRotation: 0 },
        { id: "2", x: 467, y: 79, width: 410, height: 696, rotation: 0, imageRotation: 0 },
        { id: "3", x: 885, y: 79, width: 203, height: 344, rotation: 0, imageRotation: 0 },
        { id: "4", x: 885, y: 431, width: 203, height: 344, rotation: 0, imageRotation: 0 }
    ],
}
];